import {Props} from './model';
import {useStyles} from '../../hooks/styles';
import {ResponsiveView} from '../responsiveView';
import {DeviceSize} from '../../theme/helpers';
import {View} from 'react-native';
import React from 'react';

export default ({children, icon, iconStyle, contentStyle, containerStyle}: Props) => {
  const styles = useStyles(({mediaOnly}) => ({
    sectionContent: {
      position: 'relative',
      zIndex: 1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          maxWidth: '60%',
          width: 760,
          minHeight: 576,
        },
        {
          maxWidth: '100%',
          width: '100%',
        },
      ),
    },
    sectionContainer: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    sectionIcon: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingRight: 35,
      position: 'relative',
      zIndex: 0,
    },
  }));
  return (
    <View style={[styles.sectionContainer, containerStyle]}>
      <View style={[styles.sectionContent, contentStyle]}>{children}</View>
      <ResponsiveView only={[DeviceSize.desktop]}>
        <View style={[styles.sectionIcon, iconStyle]}>{icon}</View>
      </ResponsiveView>
    </View>
  );
};
